import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface ApiError {
  statusCode: number;
  message: string;
}

const useVerifyChronologyEvent = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  return useMutation(({ factId, verified }: { factId: string; verified: boolean }) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: {
        verified: verified,
      },
    });

    if (verified) {
      return fetch(`${APIBaseChronos}/api/case/${caseId}/chronology/fact/${factId}/verify`, fetchConfig).catch(
        (error) => {
          toast.error('Failed to verify fact');
          console.error(error);
        },
      );
    } else {
      return fetch(`${APIBaseChronos}/api/case/${caseId}/chronology/fact/${factId}/unverify`, fetchConfig).catch(
        (error) => {
          toast.error('Failed to unverify fact');
          console.error(error);
        },
      );
    }
  });
};

export default useVerifyChronologyEvent;
